﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Mate } from "@models/configurators/output-fields/cad/mates/mate";
import { eOutputFieldType } from "@models/enums";
import { ICadCoincidentMate } from "@models/entity-models";
import { CToken } from "@models/configurators/ctoken";
import { KboOutputField } from "@models/configurators/configurator-di";

@KboOutputField(CToken.CadCoincidentMate, eOutputFieldType.cadCoincidentMate)
export class CadCoincidentMate extends Mate implements ICadCoincidentMate {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
}
